import React, { useRef, useState, useEffect } from 'react';

import { Scene, PerspectiveCamera, WebGLRenderer, CapsuleGeometry, Mesh, TextureLoader, Color, PCFSoftShadowMap, DirectionalLight, MeshPhongMaterial } from 'three';

function Capsule(props) {
  const canvasRef = useRef(null);
  const [width, setWidth] = useState(350);
  const [height, setHeight] = useState(400);

  useEffect(() => {
    const renderer = new WebGLRenderer({ canvas: canvasRef.current, antialias:true });
    renderer.setSize(width, height);
    renderer.shadowMap.enabled = true; // Enable shadow mapping
    renderer.shadowMap.type = PCFSoftShadowMap; // Set the type of shadow mapping
    const scene = new Scene();
    scene.background = new Color(0x046A38)
    const camera = new PerspectiveCamera(75, width / height, 0.1, 1000);
    camera.position.z = 3;

    const light = new DirectionalLight(0xffffff, 1);
    light.position.set(10, 10, 10);
    light.castShadow = true; // Enable shadow casting
    scene.add(light);


    const capsuleGeometry = new CapsuleGeometry(1, 1, 8, 20);
    const texture = new TextureLoader().load(props.texture);
    const material = new MeshPhongMaterial({ map: texture });
    const capsuleMesh = new Mesh(capsuleGeometry, material);

    capsuleMesh.castShadow = true; // Enable shadow casting
    capsuleMesh.receiveShadow = true; // Enable shadow receiving

    scene.add(capsuleMesh);



    const animate = () => {
      requestAnimationFrame(animate);
      capsuleMesh.rotation.y += props.directionY;
      renderer.render(scene, camera);
    };

    animate();

    const handleResize = () => {
      setWidth(300);
      setHeight(400);
      renderer.setSize(300, 400);
      camera.aspect = 300 / 400;
      camera.updateProjectionMatrix();
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
      renderer.dispose();
    };
  }, [props.directionY,props.texture,width,height]);

  return (
    <canvas ref={canvasRef} />
  );
}

export default Capsule;
